// Screensaver handler for WF1999 Classified Archive
import {getAppState} from './1999-state';
import {MEDIA_DIR} from './1999-audio';
const StarfieldLoopAudio = new Audio(MEDIA_DIR+'starfield-loop.mp3');
StarfieldLoopAudio.loop = true;

const TARGET_FPS = 30;
const FRAME_INTERVAL = 1000 / TARGET_FPS;
const INACTIVITY_DELAY = 30000;
const CLASS_ACTIVE = "is-active";
const CANVAS_WIDTH = 640;
const CANVAS_HEIGHT = 480;

const MODE_NONE = 0;
const MODE_LOGO = 1;
const MODE_STARFIELD = 2;

const ScreensaverBaseElement = document.querySelector('.Screensaver');
const ScreensaverCanvasElement = document.querySelector('.Screensaver-canvas');
const DrippyElement = document.querySelector('.Screensaver-drippy');
const LisetElement = document.querySelector('.Screensaver-liset');
const CanvasContext = ScreensaverCanvasElement.getContext("2d");

let dismissCallback = null;
let lastUpdate = 0;
let lastStartTime = 0;
let currentMode = 0;
let isActive = false;

const BASE_VOLUME = 0.5;
let lisetStarted = false;
let volumeMultiplier = 0;

function start() {
    isActive = true;
    lastStartTime = Date.now();
    lisetStarted = false;
    volumeMultiplier = 0;
    ScreensaverBaseElement.classList.toggle(CLASS_ACTIVE, isActive);
    clearCanvas();
}
function stop() {
    isActive = false;
    ScreensaverBaseElement.classList.toggle(CLASS_ACTIVE, isActive);
    StarfieldLoopAudio.pause();
    lisetStarted = false;
    clearCanvas();
}

function dismiss() {
    dismissCallback && dismissCallback();
}

export function setup(callback, lisetClickHandler) {
    dismissCallback = callback;
    ScreensaverBaseElement.addEventListener('click', dismiss);
    if (lisetClickHandler) {
        LisetElement.addEventListener('click', lisetClickHandler);
    }
}

export function updateMode(mode) {
    if (currentMode !== mode) {
        currentMode = mode;
        ScreensaverBaseElement.setAttribute('data-mode', mode);
        LisetElement.classList.toggle(CLASS_ACTIVE, false);
        stop();
    }
}

function updateInternal(timestamp) {
    if (timestamp - lastUpdate > FRAME_INTERVAL) {
        lastUpdate = timestamp;

        if (currentMode === MODE_LOGO) updateDrippy();
        else if (currentMode === MODE_STARFIELD) updateStarfield();
    }
}

function clearCanvas() {
    CanvasContext.clearRect(0, 0, ScreensaverCanvasElement.width, ScreensaverCanvasElement.height);
}

const DRIPPY_WIDTH = 200;
const DRIPPY_HEIGHT = 256;
const DRIPPY_INCREMENT = 4;
const DRIPPY_BUFFER = 20;
const DRIPPY_X_DELTA = DRIPPY_INCREMENT;
const DRIPPY_Y_DELTA = DRIPPY_INCREMENT;

let drippyXDir = 1;
let drippyYDir = 1;
let drippyX = 10 * DRIPPY_INCREMENT;
let drippyY = 10 * DRIPPY_INCREMENT;

function updateDrippy() {
    drippyX += DRIPPY_X_DELTA * drippyXDir;
    drippyY += DRIPPY_Y_DELTA * drippyYDir;
    DrippyElement.style.left = drippyX + 'px';
    DrippyElement.style.top = drippyY + 'px';

    const rect = ScreensaverBaseElement.getBoundingClientRect();

    if (drippyX < DRIPPY_BUFFER) drippyXDir = 1;
    else if (drippyX > (rect.width - DRIPPY_WIDTH - DRIPPY_BUFFER)) drippyXDir = -1;
    if (drippyY < DRIPPY_BUFFER) drippyYDir = 1;
    else if (drippyY > (rect.height - DRIPPY_HEIGHT - DRIPPY_BUFFER)) drippyYDir = -1;
}

const LISET_AUDIO_DELAY = 2000;
const LISET_APPEARANCE_DELAY = 5000;
const LISET_CYCLE_DELAY = 5000;
let nextLisetTimestamp = Date.now();
let stars = [];
let liset;
function updateStarfield() {
    clearCanvas();
    addStar();
    let i = stars.length - 1;
    let star;
    let size;
    CanvasContext.fillStyle = "white";
    while (i > -1) {
        star = stars[i];
        if (updateStar(star)) {
            stars.splice(i, 1);
        } else {
            star.size += 0.1;
            size = Math.floor(star.size);
            CanvasContext.fillRect(
                star.x - size / 2,
                star.y - size / 2,
                size,
                size
            )
        }
        i --;
    }
    updateLiset();
}
function updateStar(star) {
    star.dx *= 1.1;
    star.dy *= 1.1;
    star.x += star.dx;
    star.y += star.dy;
    return starOutOfView(star);
}
function updateLiset() {
    const timestamp = Date.now();
    if (timestamp - lastStartTime > LISET_AUDIO_DELAY) {
        if (lisetStarted) {
            if (volumeMultiplier < 1) {
                volumeMultiplier += 0.01;
            }
            StarfieldLoopAudio.volume = getAppState().volume * BASE_VOLUME * volumeMultiplier;
        } else {
            StarfieldLoopAudio.volume = 0;
            StarfieldLoopAudio.currentTime = 0;
            StarfieldLoopAudio.play();
            lisetStarted = true;
        }
    }
    if (timestamp - lastStartTime > LISET_APPEARANCE_DELAY) {
        if (liset) {
            if (updateStar(liset)) {
                LisetElement.classList.toggle(CLASS_ACTIVE, false);
                liset = null;
                nextLisetTimestamp = timestamp + LISET_CYCLE_DELAY;
            }
            else
            {
                LisetElement.classList.toggle(CLASS_ACTIVE, true);
                liset.size += 1;
                LisetElement.style.left = (100 * liset.x / CANVAS_WIDTH) + '%';
                LisetElement.style.top = (100 * liset.y / CANVAS_HEIGHT) + '%';
                LisetElement.style.transform = `translate(-50%, -50%) scaleX(${liset.flipped ? -1 : 1}) scale(${liset.size/100})`;
                LisetElement.classList.toggle(CLASS_ACTIVE, true);
            }
        } else if (timestamp > nextLisetTimestamp) {
            liset = {
                ... generateStarMovement(0.25, 0),
                size: 5,
                flipped: false,
            };
            liset.flipped = liset.dx > 0;
        }
    } else {
        LisetElement.classList.toggle(CLASS_ACTIVE, false);
        liset = null;
    }
}
function generateStarMovement(minSpeed = 2, speedVariance = 3) {
    const angle = Math.random() * Math.PI * 2;
    const speed = Math.random() * speedVariance + minSpeed;
    const dx = Math.cos(angle) * speed;
    const dy = Math.sin(angle) * speed;
    const distance = 10 - speed;
    const x = CANVAS_WIDTH / 2 + (dx * distance);
    const y = CANVAS_HEIGHT / 2 + (dy * distance);
    return {x, y, dx, dy};
}
function addStar() {
    stars.push({
        ... generateStarMovement(),
        size: 1,
    })
}
function starOutOfView(star) {
    return (star.x < 0 || star.x > CANVAS_WIDTH || star.y < 0 || star.y > CANVAS_HEIGHT);
}

export function update(timestamp, lastUserActivity) {
    if (currentMode === MODE_NONE) return;

    const userInactive = (timestamp - lastUserActivity) > INACTIVITY_DELAY;
    if (userInactive) {
        if (!isActive) start();
        updateInternal(timestamp);
    }
    else
    {
        if (isActive) stop();
    }
}

export default {
    setup,
    update,
    updateMode,
};
